// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Added the comments
// MODIFIED DATE : 27-09-2025

/* eslint-disable import/no-anonymous-default-export */
import CloseLoanAdvanceReducer from './close-loan-advance.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// All Loan Advance Collection Members List
	allLoanAdvanceCollectedMembersListResponse: null,
	allLoanAdvanceCollectedMembersListArr: [],
	// Particular Account Name Info
	particularAccountNameInfoResponse: null,
	particularAccountNameInfoArr: [],
	// Account Based On Type
	accountsBasedonTypeResponse: null,
	accountsBasedonTypeArr: [],
	// Update Close Loan Advance With Repayment
	updateCloseLoanAdvanceWithRepaymentResponse: null,
	updateCloseLoanAdvanceWithRepaymentArr: [],
	// Revert Close Loan Advance With Repaymet
	revertCloseLoanAdvanceWithRepaymentResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/********** GET ALL LOAN ADVANCE COLLECTED MEMBER LIST ************* */
		case CloseLoanAdvanceReducer.GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_SUCCESS:
			return {
				...state,
				allLoanAdvanceCollectedMembersListResponse: action.payload,
				allLoanAdvanceCollectedMembersListArr: docodeHexResponse(
					action.payload,
					'GetAllLoanAdvanceCollectedMemberkey',
				),
			};

		case CloseLoanAdvanceReducer.GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_FAILURE:
			return {
				...state,
				allLoanAdvanceCollectedMembersListResponse: action.payload,
			};

		case CloseLoanAdvanceReducer.GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_RESPONSE_CHANGED:
			return {
				...state,
				allLoanAdvanceCollectedMembersListResponse: null,
			};
		/********** GET ALL LOAN ADVANCE COLLECTED MEMBER LIST ************* */

		/********* FETCH PARTICULAR ACCOUNT NAME INFO ******** */
		case CloseLoanAdvanceReducer.FETCH_PARTICULAR_ACCOUNT_NAME_INFO_SUCCESS:
			return {
				...state,
				particularAccountNameInfoResponse: action.payload,
				particularAccountNameInfoArr: docodeHexResponse(
					action.payload,
					'GetParticularAccountNameInfoKey',
				),
			};

		case CloseLoanAdvanceReducer.FETCH_PARTICULAR_ACCOUNT_NAME_INFO_FAILURE:
			return {
				...state,
				particularAccountNameInfoResponse: action.payload,
			};

		case CloseLoanAdvanceReducer.FETCH_PARTICULAR_ACCOUNT_NAME_INFO_RESPONSE_CHANGED:
			return {
				...state,
				particularAccountNameInfoResponse: null,
			};
		/********* FETCH PARTICULAR ACCOUNT NAME INFO ******** */

		/*********** GET ACCOUNTS BASED ON TYPE *********** */
		case CloseLoanAdvanceReducer.GET_ACCOUNTS_BASEDON_TYPE_SUCCESS:
			return {
				...state,
				accountsBasedonTypeResponse: action.payload,
				accountsBasedonTypeArr: docodeHexResponse(
					action.payload,
					'getAccountsBasedonTypeKey',
				),
			};

		case CloseLoanAdvanceReducer.GET_ACCOUNTS_BASEDON_TYPE_FAILURE:
			return {
				...state,
				accountsBasedonTypeResponse: action.payload,
			};

		case CloseLoanAdvanceReducer.GET_ACCOUNTS_BASEDON_TYPE_RESPONSE_CHANGED:
			return {
				...state,
				accountsBasedonTypeResponse: null,
			};
		/*********** GET ACCOUNTS BASED ON TYPE *********** */

		/************ UPDATE CLOSE LOAN ADVANCE WITH REPAYMENT ************ */
		case CloseLoanAdvanceReducer.UPDATE_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_SUCCESS:
			return {
				...state,
				updateCloseLoanAdvanceWithRepaymentResponse: action.payload,
				updateCloseLoanAdvanceWithRepaymentArr: docodeHexResponse(
					action.payload,
					'updateCloseLoanAdvanceKey',
				),
			};

		case CloseLoanAdvanceReducer.UPDATE_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_FAILURE:
			return {
				...state,
				updateCloseLoanAdvanceWithRepaymentResponse: action.payload,
			};

		case CloseLoanAdvanceReducer.UPDATE_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_RESPONSE_CHANGED:
			return {
				...state,
				updateCloseLoanAdvanceWithRepaymentResponse: null,
			};
		/************ UPDATE CLOSE LOAN ADVANCE WITH REPAYMENT ************ */

		/*********** REVERT CLOSE LOAN ADVANCE WITH REPAYMENT ********** */
		case CloseLoanAdvanceReducer.REVERT_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_SUCCESS:
			return {
				...state,
				revertCloseLoanAdvanceWithRepaymentResponse: action.payload,
			};

		case CloseLoanAdvanceReducer.REVERT_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_FAILURE:
			return {
				...state,
				revertCloseLoanAdvanceWithRepaymentResponse: action.payload,
			};

		case CloseLoanAdvanceReducer.REVERT_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_RESPONSE_CHANGED:
			return {
				...state,
				revertCloseLoanAdvanceWithRepaymentResponse: null,
			};
		/*********** REVERT CLOSE LOAN ADVANCE WITH REPAYMENT ********** */

		default:
			return state;
	}
};
